import { memo, type ReactElement } from 'react';

import { useIsLargeScreen } from '@bestseller-bit/frontend-community.theme.buying-theme';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { alpha, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface SelectionStatusProps {
    descriptionText: string;
    selectedAmountText: string;
    cancelAction: () => void;
}

const SelectionStatus = memo(
    ({
        descriptionText,
        selectedAmountText,
        cancelAction,
    }: SelectionStatusProps): ReactElement => {
        const { palette } = useTheme();
        const isLargeScreen = useIsLargeScreen();

        return (
            <Stack
                direction="row"
                spacing={5}
                sx={{
                    alignItems: 'center',
                }}
            >
                <Button
                    key="cancel-button"
                    variant="outlined"
                    onClick={() => {
                        cancelAction();
                    }}
                >
                    Cancel
                </Button>
                <Stack>
                    <Typography
                        variant="bodySmall.default"
                        sx={{ color: alpha(palette.primary.main, 0.5) }}
                    >
                        {descriptionText}
                    </Typography>

                    <Typography
                        variant={
                            isLargeScreen ? 'headings.h4' : 'buttons.small'
                        }
                        sx={{ textWrap: 'balance' }}
                    >
                        {selectedAmountText}
                    </Typography>
                </Stack>
            </Stack>
        );
    }
);

SelectionStatus.displayName = 'SelectionStatus';

export { SelectionStatus };
